import React, { useMemo } from 'react';
import SearchableSelect from '../Common/SearchableSelect';

const VISIT_TYPE_OPTIONS = [
  { value: '', label: 'All Visit Types' },
  { value: 'SSV', label: 'Site Selection Visit' },
  { value: 'SIV', label: 'Site Initiation Visit' },
  { value: 'SMV', label: 'Site Monitoring Visit' },
  { value: 'SCV', label: 'Site Close Out Visit' },
];

const VisitLetterFilters = ({
  sites,
  siteId,
  visitType,
  searchTerm,
  onSiteChange,
  onVisitTypeChange,
  onSearchChange,
  disabled,
}) => {
  const siteOptions = useMemo(
    () => (sites || []).map((site) => {
      const id = site.siteID ?? site.siteId ?? site.SiteNo ?? site.siteNo;
      const code = site.siteCode ?? site.SiteCode ?? site.vSiteCode ?? '';
      const desc = site.siteDescription ?? site.SiteDescription ?? site.vSiteDescription ?? '';
      const label = site.siteDisplay || [code, desc].filter(Boolean).join(' - ') || String(id);
      return { value: String(id), label };
    }),
    [sites]
  );

  return (
    <div className="visit-letter-filters">
      <div className="visit-letter-filter-item visit-letter-filter-site">
        <label className="form-label" htmlFor="visit-letter-site">Site</label>
        <SearchableSelect
          name="siteId"
          value={siteId}
          options={siteOptions}
          onChange={(e) => onSiteChange(e.target.value)}
          placeholder="All Sites"
          emptyOptionLabel="All Sites"
          searchPlaceholder="Search by site code or name…"
          disabled={disabled}
        />
      </div>
      <div className="visit-letter-filter-item">
        <label className="form-label" htmlFor="visit-letter-visit-type">Visit Type</label>
        <select
          id="visit-letter-visit-type"
          className="form-select"
          value={visitType}
          onChange={(e) => onVisitTypeChange(e.target.value)}
          disabled={disabled}
        >
          {VISIT_TYPE_OPTIONS.map((opt) => (
            <option key={opt.value || 'all'} value={opt.value}>{opt.label}</option>
          ))}
        </select>
      </div>
      <div className="visit-letter-filter-item visit-letter-filter-search">
        <label className="form-label" htmlFor="visit-letter-search">Search</label>
        <input
          id="visit-letter-search"
          type="text"
          className="form-input"
          placeholder="Visit ID, site, type..."
          value={searchTerm}
          onChange={(e) => onSearchChange(e.target.value)}
          disabled={disabled}
        />
      </div>
    </div>
  );
};

export default VisitLetterFilters;
